import { render, staticRenderFns } from "./DisclosureStatement.vue?vue&type=template&id=6f8e424f&scoped=true"
import script from "./DisclosureStatement.vue?vue&type=script&lang=js"
export * from "./DisclosureStatement.vue?vue&type=script&lang=js"
import style0 from "./DisclosureStatement.vue?vue&type=style&index=0&id=6f8e424f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8e424f",
  null
  
)

export default component.exports